import type { CMSAssetSidebarItem } from '../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL, GET_LIST_ASSET_KEY } from '../constants';

type GetListAssetsResponse = CMSAssetSidebarItem[];

const getListAssets = (): Promise<GetListAssetsResponse> => {
  const url = `${CMS_API_ROOT_URL}/assets`;
  return FetchPromise.get(`${url}`);
};

export const useGetListAssets = () =>
  useQuery<GetListAssetsResponse, JQuery.jqXHR>([GET_LIST_ASSET_KEY], () => getListAssets());
